/**
 * storeAuthorBlocks
 *
 * Downloads the latest version blob for a report, extracts per-author text
 * blocks, and writes them to the Firestore report doc as `authorBlocks`.
 *
 * This is called (fire-and-forget) when a report is fully approved.
 * The stored data is later read by the expert profile update service.
 */
import {updateReportDoc} from '../../firebase/firestore/reports';
import {parseVersionFromSnapshotPath} from '../products/previewPage/useReportDocumentSubscription';
import {extractAuthorBlocks} from './extractAuthorBlocks';
import {downloadReportVersionFromApi} from '../../utils/api/reportVersions';

/**
 * Download the latest version blob for the given report and store `authorBlocks`
 * in the Firestore report document.
 *
 * @param {string} reportId - Firestore report doc ID
 * @param {string} snapshotPath - gs:// path from report.snapshotPath
 */
export async function storeAuthorBlocks(reportId, snapshotPath) {
    if (!reportId || !snapshotPath) return;

    const version = parseVersionFromSnapshotPath(snapshotPath);
    if (!version) return;

    try {
        const parsed = await downloadReportVersionFromApi(reportId, version);
        if (!parsed) return;

        const {references: _refs, ...contentData} = parsed;
        const authorBlocks = extractAuthorBlocks(contentData);

        if (Object.keys(authorBlocks).length === 0) return;

        await updateReportDoc(reportId, {authorBlocks});
    } catch (err) {
        console.error('[storeAuthorBlocks] Failed:', err);
    }
}
